/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientView
 */
export interface ClientView {
    /**
     * 
     * @type {string}
     * @memberof ClientView
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientView
     */
    firmId?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientView
     */
    contactFirstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientView
     */
    contactLastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientView
     */
    contactEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientView
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientView
     */
    aliases?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientView
     */
    respondentName?: string | null;
}

export function ClientViewFromJSON(json: any): ClientView {
    return ClientViewFromJSONTyped(json, false);
}

export function ClientViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'firmId': !exists(json, 'firmId') ? undefined : json['firmId'],
        'contactFirstName': !exists(json, 'contactFirstName') ? undefined : json['contactFirstName'],
        'contactLastName': !exists(json, 'contactLastName') ? undefined : json['contactLastName'],
        'contactEmail': !exists(json, 'contactEmail') ? undefined : json['contactEmail'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'aliases': !exists(json, 'aliases') ? undefined : json['aliases'],
        'respondentName': !exists(json, 'respondentName') ? undefined : json['respondentName'],
    };
}

export function ClientViewToJSON(value?: ClientView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'firmId': value.firmId,
        'contactFirstName': value.contactFirstName,
        'contactLastName': value.contactLastName,
        'contactEmail': value.contactEmail,
        'name': value.name,
        'aliases': value.aliases,
        'respondentName': value.respondentName,
    };
}


